import api from "../index"

const kycApi = api.injectEndpoints({
  endpoints: (build) => ({
    getKycData: build.query({
      query: () => ({
        url: `/kyc/all/data`,
        method: "GET",
      }),
    }),
    getOtpPhoneVerification: build.mutation({
      query: (body) => ({
        url: `/kyc/get_otp`,
        method: "POST",
        body,
      }),
    }),
    updateDiogioRequestStatus: build.mutation({
      query: ({ id }) => ({
        url: `/kyc/update/diogio/request/status/${id}`,
        method: "GET",
      }),
    }),
    generateTemplateToken: build.mutation({
      query: (body) => ({
        url: `/kyc/generate/token`,
        method: "POST",
        body,
      }),
    }),
    getStatusOfOldDigioRequest: build.query({
      query: ({ template_name }) => ({
        url: `/kyc/get/digio/resuqest/status?template_name=${template_name}`,
        method: "GET",
      }),
    }),
    verifyOtpPhoneVerification: build.mutation({
      query: (body) => ({
        url: `/kyc/verify_otp`,
        method: "POST",
        body,
      }),
    }),
    storeAdditionalDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/additional_details`,
        method: "POST",
        body,
      }),
    }),

    storeBusinessAdditionalDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/business_additional_details`,
        method: "POST",
        body,
      }),
    }),
    updateBusinessSignatoryDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/update/business/signatory`,
        method: "POST",
        body,
      }),
    }),
    uploadAuthorityLetter: build.mutation({
      query: (body) => ({
        url: `/kyc/upload/authority/letter`,
        method: "POST",
        body,
      }),
    }),
    uploadSignatureValidation: build.mutation({
      query: (body) => ({
        url: `/kyc/upload/signature`,
        method: "POST",
        body,
      }),
    }),

    businessDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/save_company_details`,
        method: "POST",
        body,
      }),
    }),
    updateDematDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/update/demat/account`,
        method: "POST",
        body,
      }),
    }),
    updateIcdAgreementDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/update/icd/agreement`,
        method: "POST",
        body,
      }),
    }),
    businessDetailsManually: build.mutation({
      query: (body) => ({
        url: `/kyc/company_details/manually`,
        method: "POST",
        body,
      }),
    }),
    updateKycStep: build.mutation({
      query: (body) => ({
        url: `/kyc/update/step`,
        method: "POST",
        body,
      }),
    }),
    updateBankDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/update/bank/details`,
        method: "POST",
        body,
      }),
    }),
    fetchBankDetails: build.mutation({
      query: (body) => ({
        url: `/kyc/bank/fetch`,
        method: "POST",
        body,
      }),
    }),
    kycFinalSubmission: build.mutation({
      query: (body) => ({
        url: `/kyc/final/submission`,
        method: "POST",
        body,
      }),
    }),
    resolveQuerySteps: build.query({
      query: (body) => ({
        url: `/kyc/resolve/query/steps`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetKycDataQuery,
  useGetOtpPhoneVerificationMutation,
  useUpdateDiogioRequestStatusMutation,
  useGenerateTemplateTokenMutation,
  useLazyGetStatusOfOldDigioRequestQuery,
  useVerifyOtpPhoneVerificationMutation,
  useStoreAdditionalDetailsMutation,
  useStoreBusinessAdditionalDetailsMutation,
  useUpdateBusinessSignatoryDetailsMutation,
  useUploadSignatureValidationMutation,
  useBusinessDetailsMutation,
  useBusinessDetailsManuallyMutation,
  useUpdateDematDetailsMutation,
  useUpdateIcdAgreementDetailsMutation,
  useUpdateKycStepMutation,
  useUpdateBankDetailsMutation,
  useFetchBankDetailsMutation,
  useUploadAuthorityLetterMutation,
  useKycFinalSubmissionMutation,
  useLazyResolveQueryStepsQuery,
  useResolveQueryStepsQuery,
} = kycApi
